import { ProviderUserTypeGroup } from './providerUserType';

const getLevel1Text = providerUserTypeGroup => {
	switch (providerUserTypeGroup) {
		case ProviderUserTypeGroup.Clinical:
		case ProviderUserTypeGroup.Rehab:
			return 'Users are granted full access to all features of ASHLink with the exception of seeing CPS letters.';
		case ProviderUserTypeGroup.HealthplanProvider:
			return 'Users are granted full access to all features of ASHLink with the exception of submitting quarterly validations.';
		case ProviderUserTypeGroup.HealthplanAdmin:
			return 'Users are granted full access to all features of ASHLink.';
	}
};

const getLevel2Text = userTypeGroup => {
	switch (userTypeGroup) {
		case ProviderUserTypeGroup.Clinical:
		case ProviderUserTypeGroup.Rehab:
			return 'Same permissions as Level 1 - With the exception of inviting and creating sub accounts.';
		case ProviderUserTypeGroup.HealthplanProvider:
		case ProviderUserTypeGroup.HealthplanAdmin:
			return 'Same permissions as Level 1 - With the exception of creating sub accounts.';
	}
};

const getLevel3Text = userTypeGroup => {
	switch (userTypeGroup) {
		case ProviderUserTypeGroup.Clinical:
		case ProviderUserTypeGroup.Rehab:
			return 'Same permissions as Level 2 - With the exception of seeing payments, remittance advice, and specified resources.';
		case ProviderUserTypeGroup.HealthplanProvider:
			return 'Same permissions as Level 2 - With the exception of accessing resources.';
		case ProviderUserTypeGroup.HealthplanAdmin:
			return 'Same permissions as Level 2.';
	}
};

export { getLevel1Text, getLevel2Text, getLevel3Text };
